// extracted by mini-css-extract-plugin
export default {"container":"Separator_container__G-cnp","text":"Separator_text__xTVPR","line":"Separator_line__sLf7K"};